export default 'https://mail.pilsnerurquellguide.com/kozel/'
